import React, { useEffect, useState } from "react";
import API from "../services/adminApi";
import "../../styles/admin.css";

function Dashboard() {
  const [stats, setStats] = useState({
    programs: 0,
    members: 0,
    health: 0,
    environment: 0,
    reports: 0,
    testimonials: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    async function fetchStats() {
      try {
        setLoading(true);

        const [
          programsRes,
          membersRes,
          healthRes,
          environmentRes,
          reportsRes,
          testimonialsRes,
        ] = await Promise.all([
          API.get("programs/"),
          API.get("members/"),
          API.get("health/"),
          API.get("environment/"),
          API.get("reports/"),
          API.get("testimonials/"),
        ]);

        setStats({
          programs: programsRes?.data?.length || 0,
          members: membersRes?.data?.length || 0,
          health: healthRes?.data?.length || 0,
          environment: environmentRes?.data?.length || 0,
          reports: reportsRes?.data?.length || 0,
          testimonials: testimonialsRes?.data?.length || 0,
        });
      } catch (err) {
        console.error("Dashboard stats error:", err);
        setError("Failed to load dashboard data.");
      } finally {
        setLoading(false);
      }
    }

    fetchStats();
  }, []);

  if (loading) {
    return <div className="admin-loading">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="admin-error">{error}</div>;
  }

  return (
    <div className="dashboard-container">

      {/* HEADER */}
      <div className="dashboard-header">
        <div>
          <h1>Admin Dashboard</h1>
          <p>Manage all website content from here</p>
        </div>

        <div className="admin-profile">
          <button
            className="profile-btn"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            Admin ▾
          </button>

          {dropdownOpen && (
            <div className="profile-dropdown">
              <p>Profile</p>
              <p>Settings</p>
              <p>Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* STATS CARDS */}
      <div className="stats-grid">
        <div className="stat-card blue">
          <h3>Total Programs</h3>
          <h2>{stats.programs}</h2>
        </div>

        <div className="stat-card purple">
          <h3>Total Members</h3>
          <h2>{stats.members}</h2>
        </div>

        <div className="stat-card green">
          <h3>Health Posts</h3>
          <h2>{stats.health}</h2>
        </div>

        <div className="stat-card orange">
          <h3>Environment Posts</h3>
          <h2>{stats.environment}</h2>
        </div>

        <div className="stat-card pink">
          <h3>Reports</h3>
          <h2>{stats.reports}</h2>
        </div>

        <div className="stat-card teal">
          <h3>Testimonials</h3>
          <h2>{stats.testimonials}</h2>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;